import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {Router} from '@angular/router';
import {NgForm} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {DobryAgentBlogTag} from '../../../../shared/interface/dobry-agent-blog-article';
import {DobryAgentBlogTagService} from '../../../../shared/services/dobry-agent-blog-tag.service';
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-da-tag-add',
  templateUrl: './da-tag-add.component.html',
  styleUrls: ['./da-tag-add.component.scss']
})
export class DaTagAddComponent implements OnInit, OnChanges, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @Input() blogTag?: DobryAgentBlogTag;
  @Input() mod = false;

  @Output() closeModification = new EventEmitter<void>();

  uuid?: string;
  isEditMode = false;
  loading = false;
  saving = false;

  model: Partial<DobryAgentBlogTag> = {
    name: '',
    active: true,
  };

  constructor(
    private router: Router,
    private snackBar: MatSnackBar,
    private blogTagService: DobryAgentBlogTagService,
  ) {
  }

  ngOnInit(): void {
    if (this.mod && this.blogTag) {
      this.setModel(this.blogTag);
      return;
    }

    this.isEditMode = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.blogTag && this.blogTag) {
      this.setModel(this.blogTag);
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  save(form: NgForm, addNext = false): void {
    if (form.invalid || this.saving) {
      form.control.markAllAsTouched();
      return;
    }

    this.saving = true;

    const formData = {
      name: this.model.name,
      active: !!this.model.active,
    };

    this.blogTagService.send(formData, this.uuid)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (result: { uuid: string }) => {
          this.saving = false;

          this.snackBar.open(
            this.isEditMode ? 'Tag został zapisany.' : 'Tag został dodany.',
            'Zamknij',
            {duration: 3000}
          );

          if (this.mod) {
            this.closeModification.emit();
            return;
          }

          if (addNext) {
            this.resetForm(form);
            return;
          }

          if (result?.uuid) {
            this.router.navigate(['/blog-dobry-agent/tagi/szczegoly', result.uuid]);
            return;
          }

          this.router.navigate(['/blog-dobry-agent/tagi']);
        },
        error: (error: HttpErrorResponse) => {
          this.saving = false;

          const backendError = error.error?.error;
          const nameErrors = backendError?.list?.name;

          if (nameErrors?.length) {
            form.controls.name?.setErrors({
              backend: nameErrors[0]
            });

            form.controls.name?.markAsTouched();

            this.snackBar.open(
              nameErrors[0],
              'Zamknij',
              {duration: 4000}
            );

            return;
          }

          this.snackBar.open(
            backendError?.text || 'Nie udało się zapisać taga. Sprawdź formularz i spróbuj ponownie.',
            'Zamknij',
            {duration: 4000}
          );
        }
      });
  }
  cancel(): void {
    if (this.mod) {
      this.closeModification.emit();
      return;
    }

    this.router.navigate(['/blog-dobry-agent/tagi']);
  }

  private setModel(tag: DobryAgentBlogTag): void {
    this.uuid = tag.uuid;
    this.isEditMode = true;

    this.model = {
      uuid: tag.uuid,
      name: tag.name ?? '',
      active: tag.active ?? false,
    };
  }

  private resetForm(form: NgForm): void {
    this.uuid = undefined;
    this.isEditMode = false;

    this.model = {
      name: '',
      active: true,
    };

    form.resetForm(this.model);
  }
}
